require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./es-articles-financial-center-employee-named-a-rock-star-by-credit-union-magazine.json") })
        }
      }, "path---es-articles-financial-center-employee-named-a-rock-star-by-credit-union-magazine");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---es-articles-financial-center-employee-named-a-rock-star-by-credit-union-magazine!./.cache/json/es-articles-financial-center-employee-named-a-rock-star-by-credit-union-magazine.json
// module id = 2084
// module chunks = 231608221292675